import { useState } from 'react';

import { TabsContent } from '@repo/videa-components/src/ui/tabs';
import classNames from 'classnames';

import { useImageFallback } from '@/utils/hooks';

import type { AdultTreatmentKey } from './AdultTabs';
import type { PediatricTreatmentKey } from './PediatricTabs';

interface Props {
  fallback: string;
  src: string;
  tabKey: AdultTreatmentKey | PediatricTreatmentKey;
}

export const TreatmentTabContent = ({ fallback, src, tabKey }: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { imgSrc, onError } = useImageFallback(src, fallback);

  return (
    <TabsContent key={tabKey} value={tabKey}>
      <div
        className="vai-flex vai-justify-center"
        data-testid={`tab-content-${tabKey}`}
      >
        {!isLoaded && <div className="vai-h-[500px] vai-bg-transparent" />}
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <img
          alt={tabKey}
          className={classNames(
            'vai-max-h-[500px] vai-transition-opacity vai-duration-300',
            {
              'vai-opacity-100': isLoaded,
              'vai-opacity-0': !isLoaded,
            },
          )}
          onLoad={() => setIsLoaded(true)}
          onError={onError}
          src={imgSrc}
        />
      </div>
    </TabsContent>
  );
};
